/**
 * @file 封装请求数据接口
 * @author quda
 */
import {jsonp} from '@baidu/map-fe-utils';
import Const from './constant/Constant';
import {makeSign} from './helper/crypto';

export default (url, reqParams = {}, options = {}) => {
    if (!url) {
        throw new Error('[Error] request url is required!');
    }

    const slot = 'xYhGb&l&*t8e';

    // from是outmap对应的salt
    const outmapSlot = 'Ye@ds*nDx&ns';

    // 接口path
    let addressUrl = Const.dataUrl[url];
    if (addressUrl && addressUrl.isMock === 1) {
        const mockData = require('./mocks/index');
        let data = mockData.default[addressUrl.url];
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                if (data) {
                    resolve(data);
                }
                else {
                    reject({
                        errno: -3,
                        errmsg: '[ERROR] Time out.',
                        data: {}
                    });
                }
            }, 50);
        });
    }

    // 兼容获取留言接口，cuid传则必须有值，没有值cuid也不能传，cuid也会参与签名
    if (options && options.noCuid) {
        delete reqParams.cuid;
    }
    if (options && options.need_sign && !options.outmap) {
        // 统一添加签名验证
        reqParams.from = 'h5map';
        reqParams.pano_sign = makeSign(reqParams, slot);
    }
    if (options && options.need_sign && options.outmap) {
        // from是outmap
        reqParams.from = 'outmap';
        reqParams.pano_sign = makeSign(reqParams, outmapSlot);
    }

    return jsonp(addressUrl.url, reqParams, options);
};
